import Preferences from "../../../components/Admin/Preferences";
import { MItem } from "../Menu";
import PlaningToolRoot from "../PlaningToolRoot";

export default function SPPreferences(props: {
  standalone?: boolean,
  className?: string,
}) {
  const className = `SPPreferences flex flex-column ${props.className || ''}`
  return <PlaningToolRoot standalone={true} menuItem={MItem.customers} mainContentClass={className}>
    <>
      <Preferences version='core' />
    </>
  </PlaningToolRoot>
}
